import React from 'react';
import Footer from './Footer';
import SigninHeader from 'Components/Account/SigninHeader';
import SubscriptionSection from './SubscriptionSection';

function PricingInfo() {
  return (
   <div className='w-full h-full  '>
    <SigninHeader/>
    <div className=' w-full h-full'>
    <SubscriptionSection/>
    </div>
    <Footer/>
 </div>
  )
}

export default PricingInfo
